export default "__VITE_ASSET__DeFvgZ1H__"